;(function() {
  'use strict'

  Controller.$inject = ["glDialog", "imageService"];
  angular.module('glow.reporting').component('surveyExplorerSettingsDialog', {
    controller: Controller,
    templateUrl: 'survey-explorer-settings-dialog.html',
    bindings: {
      dashboard: '<',
      onApply: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller(glDialog, imageService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.toggle = toggle
    ctrl.apply = apply
    ctrl.cancel = cancel
    ctrl.remove = remove
    ctrl.setImage = setImage

    function onInit() {
      // ...
    }

    function toggle(prop) {
      if (ctrl.dashboard.weightScheme.enabled) return
      ctrl.dashboard[prop].enabled = !ctrl.dashboard[prop].enabled
    }

    function apply() {
      ctrl.errors = null
      if (!ctrl.dashboard.validate()) {
        ctrl.errors = ctrl.dashboard.errors
        return
      }
      ctrl.onApply({})
    }

    function cancel() {
      ctrl.onCancel()
    }

    function remove() {
      glDialog
        .confirm(
          'Delete Dashboard',
          'Are you sure you want to delete this dashboard? This action cannot be reverted.'
        )
        .then(function() {
          ctrl.onApply({ $remove: true })
        })
    }

    function setImage(imageData) {
      if (!imageData) {
        ctrl.dashboard.logoImageUrl = null
        return
      }
      ctrl.uploadingImage = true
      imageService
        .create(imageData)
        .then(function(imageUrl) {
          ctrl.dashboard.logoImageUrl = imageUrl
        })
        .finally(function() {
          ctrl.uploadingImage = false
        })
    }
  }
})()
